var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box mb-4 certificado-card", class: _vm.estadoBorderClass },
    [
      _c(
        "div",
        {
          staticClass:
            "is-flex is-justify-content-space-between is-align-items-center mb-2",
        },
        [
          _c("div", [
            _c("p", { staticClass: "has-text-weight-semibold" }, [
              _vm._v(
                "\n        Certificado #" +
                  _vm._s(_vm.certificado.id) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "is-size-7 has-text-grey" }, [
              _vm._v(
                "\n        Serie: " +
                  _vm._s(_vm.certificado.numero_serie) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "tag is-rounded", class: _vm.estadoTagType },
            [_vm._v("\n      " + _vm._s(_vm.certificado.estado) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "my-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "content is-small" }, [
        _vm.certificado.usuario
          ? _c("p", [
              _c("strong", [_vm._v("Titular:")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.certificado.usuario.nombre) +
                  " " +
                  _vm._s(_vm.certificado.usuario.apellido) +
                  "\n    "
              ),
            ])
          : _c("p", { staticClass: "has-text-grey" }, [
              _vm._v("\n      Usuario no disponible\n    "),
            ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("DN:")]),
          _vm._v(" "),
          _c("span", { staticClass: "has-text-grey" }, [
            _vm._v("\n        " + _vm._s(_vm.certificado.dn) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns is-mobile" }, [
          _c("div", { staticClass: "column" }, [
            _c("strong", [_vm._v("Emisión")]),
            _c("br"),
            _vm._v(
              "\n        " +
                _vm._s(_vm.formatDate(_vm.certificado.fecha_emision)) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("strong", [_vm._v("Vencimiento")]),
            _c("br"),
            _vm._v(
              "\n        " +
                _vm._s(_vm.formatDate(_vm.certificado.fecha_vencimiento)) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("strong", [_vm._v("Días restantes")]),
            _c("br"),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.calcDiasRestantes(_vm.certificado.fecha_vencimiento)
                ) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.certificado.por_vencer
        ? _c(
            "div",
            { staticClass: "notification is-warning is-light mt-3 is-size-7" },
            [_vm._v("\n    Este certificado está próximo a vencer\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }